import './style.scss'

import React, { Component } from 'react'

import Button from 'components/UI/Button'
import PropTypes from 'prop-types'
import Switch from 'components/UI/Switch'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { toggleGift } from 'actions/Gift'
import { withTranslation } from 'react-i18next'

class CartGiftOrCoupon extends Component {
    render() {
        const { dispatch, hidden, isGift, t } = this.props
        if (hidden) return null
        return (
            <div className="cart-gift-or-coupon">
                <div className="cart-gift-or-coupon__gift">
                    <div>
                        <span className="cart-gift-or-coupon__gift--text">
                            {t('cartToggleGift')}
                        </span>
                        <span className="cart-gift-or-coupon__gift--help">
                            {t('cartToggleGiftHelpText')}
                        </span>
                    </div>
                    <Switch on={isGift} onChange={() => dispatch(toggleGift(!isGift))} />
                </div>

                <Button variant="mobile" onClick={() => dispatch(push('/checkout/code'))}>
                    {t('cartSetCoupon')}
                </Button>
            </div>
        )
    }
}

CartGiftOrCoupon.propTypes = {
    hidden: PropTypes.bool,
    isGift: PropTypes.bool,
    t: PropTypes.func,
    dispatch: PropTypes.func,
}

function mapStateToProps({ features, cart, gift }) {
    return {
        isGift: gift.isGift,
        hidden: !features.oneClickCheckoutEnabled || cart.products.length < 1,
    }
}

export default connect(mapStateToProps)(withTranslation()(CartGiftOrCoupon))
